import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const usePostScanQrApprove = (callback = () => {}) => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const request = (account_idx, eventIdx, serial_number) => {
		fetchRequest('POST', `/admin/event/allow-user-join`, {
			account_idx: account_idx,
			event_idx: eventIdx,
			...(serial_number && {serial_number}),
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				callback()
				break
			case 400:
				if (fetchResult?.data?.error_code === 'qr_token') {
					setAlert('QR 토큰 형식이 잘못되었습니다.')
				} else if (fetchResult?.data?.error_code === 'event_idx') {
					setAlert('이벤트 ID를 확인해 주세요.')
				} else if (fetchResult?.data?.message) {
					setAlert(fetchResult?.data?.message)
				} else {
					setAlert('입력한 값의 형식이 잘못되었습니다.')
				}
				break
			case 403:
				if (fetchResult?.data?.message) {
					setAlert(fetchResult?.data?.message)
				} else {
					setAlert('QR 코드에 대한 접근 권한이 없습니다.')
				}
				break
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('유효하지 않은 QR 코드입니다.')
				} else if (fetchResult?.data?.error_code === 2) {
					setAlert('이벤트 데이터가 존재하지 않습니다.')
				} else if (fetchResult?.data?.message) {
					setAlert(fetchResult?.data?.message)
				} else {
					setAlert('요청한 데이터를 찾을 수 없습니다.')
				}
				break
			case 409:
				setAlert('이미 승인된 QR 코드입니다.')
				break
			case 500:
				if (fetchResult?.data?.message) {
					setAlert(fetchResult?.data?.message)
				} else if (fetchResult?.data?.message) {
					setAlert(fetchResult?.data?.message)
				} else {
					setAlert('서버 오류가 발생했습니다.')
				}
				break
			default:
				break
		}
	}, [fetchResult])

	return [request, isLoading, fetchResult]
}

export default usePostScanQrApprove
